import { UsersClient } from '@src/manageUsers/services/UsersClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUserDeactivation = () => {
  const queryClient = useQueryClient();
  const { mutate: deactivateUser, isPending: isDeactivating } = useMutation({
    mutationFn: (userId: string) => UsersClient.deactivate(userId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users.list'] });
    },
  });

  const { mutate: reactivateUser, isPending: isReactivating } = useMutation({
    mutationFn: (userId: string) => UsersClient.activate(userId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users.list'] });
    },
  });

  const { mutate: confirmCognitoUser, isPending: isConfirming } = useMutation({
    mutationFn: (userId: string) => UsersClient.confirmCognitoUser(userId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users.list'] });
    },
  });

  return {
    deactivateUser,
    reactivateUser,
    confirmCognitoUser,
    isLoading: isDeactivating || isReactivating || isConfirming,
  };
};
